import Component from "../Component";
import React from "react";
import {ProgressBar} from "react-step-progress-bar";
import Dropzone from "react-dropzone-uploader";

const formatBytes = (b) => {
    const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let l = 0
    let n = b

    while (n >= 1024) {
        n /= 1024
        l += 1
    }

    return `${n.toFixed(n >= 10 || l < 1 ? 0 : 1)}${units[l]}`
}

const formatDuration = (seconds) => {
    const date = new Date(0)
    date.setSeconds(seconds)
    const dateString = date.toISOString().slice(11, 19)
    if (seconds < 3600) return dateString.slice(3)
    return dateString
}

export default class MultiFileUpload extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    getUploadParams = ({ file, meta }) => {
        let params = {
            ...this.props.uploadParams
        };

        let fields = {};
        for (let[key, value] of Object.entries(meta)){
            fields[key] = value;
        }

        fields['path']= file;

        if (this.props.filePathProp) {
            return {...params, fields: {[this.props.filePathProp]: file}};
        }else {
            params.fields = {...fields, ...(params.fields || {})};
        }
        return params;
    }

    onStatusChange = async(file, status, files) => {

        if (status === 'done') {
            let response = JSON.parse(file.xhr.response);

            await this.props.onFileUploaded(response, file)
        }
    }

    handleSubmit = (files, allFiles) => {
        console.log('handleSubmit', {files, allFiles})
    }

    previewComponent = (props) => {
        const {
            className,
            imageClassName,
            style,
            imageStyle,
            fileWithMeta: { cancel, remove, restart },
            meta: { name = '', percent = 0, size = 0, previewUrl, status, duration, validationError },
            isUpload,
            canCancel,
            canRemove,
            canRestart,
            extra: { minSizeBytes },
        } = props;

        let title = `${name || '?'}, ${formatBytes(size)}`
        if (duration) title = `${title}, ${formatDuration(duration)}`

        if (status === 'error_file_size' || status === 'error_validation') {
            return (
                <div className={className} style={style}>
                    <span className="dzu-previewFileNameError">{title}</span>
                    {status === 'error_file_size' && <span>{size < minSizeBytes ? 'File too small' : 'File too big'}</span>}
                    {status === 'error_validation' && <span>{String(validationError)}</span>}
                    {canRemove && <i className="dzu-previewButton fa fa-times text-dark" onClick={remove} />}
                </div>
            )
        }

        if (status === 'error_upload_params' || status === 'exception_upload' || status === 'error_upload') {
            title = (
                <span>{title} <span className="text-danger">(upload failed)</span></span>
            )
        }
        if (status === 'aborted') title = (
            <span>{title} <span className="text-danger">(cancelled)</span></span>
        )
        return (
            <div className={className} style={style}>
                {previewUrl && <img className={imageClassName} style={imageStyle} src={previewUrl} alt={title} title={title} />}
                {!previewUrl && <span className="dzu-previewFileName">{title}</span>}

                <div className="dzu-previewStatusContainer">
                    {isUpload && (
                        <div className="position-relative flex-grow text-dark" style={{width: 200}}>
                            <ProgressBar
                                height={18}
                                percent={(percent > 99.9 && status === 'uploading') ? 99 : percent}
                                unfilledBackground={'#ffffff'}
                                filledBackground={TB.config("color.green")}
                                text={(percent > 99.9 && status === 'uploading') ? "99.99" : percent.toFixed(2) + '%'}
                            />
                        </div>
                    )}

                    {status === 'uploading' && canCancel && (
                        <i className="dzu-previewButton fa fa-times text-dark" onClick={cancel} />
                    )}
                    {percent < 100 && status !== 'preparing' && status !== 'getting_upload_params' && status !== 'uploading' && canRemove && (
                        <i className="dzu-previewButton fa fa-times text-dark" onClick={remove} />
                    )}
                    {['error_upload_params', 'exception_upload', 'error_upload', 'aborted', 'ready'].includes(status) &&
                    canRestart && <i className="dzu-previewButton fa fa-play text-dark" onClick={restart} />}
                </div>
            </div>
        )
    }

    renderLayout = ({input, previews, submitButton, dropzoneProps, files, extra: {maxFiles, active}}) => {

        return (
            <div className="talent-document-upload-form file-upload-container form-group position-relative">
                {previews}

                <div {...dropzoneProps} className={"image-drop-input " + (active && 'drag-active')}>


                    <div className="btn-file">
                        {active ? <p>Drop the files here ...</p> : [
                            <p key={"image-drop-instructions"}>
                                To upload a file drag here or
                                <b className="text-primary">
                                    browse
                                </b>
                            </p>,
                            <i key="image-drop-instructions-icon" className="fas fa-plus-circle"/>
                        ]}
                    </div>
                    {input}

                </div>
            </div>
        )
    }


    render() {
        return (
            <Dropzone
                inputContent={""}
                inputWithFilesContent={""}
                maxSizeBytes={100 * 1024 * 1024}
                maxFiles={this.props.maxFiles}

                // initialFiles={this.props.initialFiles}
                multiple={TB.isDefined(this.props.multiple) ? this.props.multiple : true}
                PreviewComponent={this.previewComponent}
                onChangeStatus={this.onStatusChange}
                getUploadParams={this.getUploadParams}
                LayoutComponent={this.renderLayout}
                onSubmit={this.handleSubmit}
            />
        )
    }
}